
// 公共内容國際化
const publicObj = {
  Cancel: {
      'en':"Cancel",
      'zh-cn': '取消',
      'zh-hk': '取消',
  },
  Confirm: {
      'en':"Confirm",
      'zh-cn': '确认',
      'zh-hk': '確認',
  },
  Success: {
      'en':"Success",
      'zh-cn': '成功',
      'zh-hk': '成功',
  },
  Close: {
      'en':"Close",
      'zh-cn': '关闭',
      'zh-hk': '關閉',
  },
NewFunctionComingSoonWidthScreen: {
  'zh-cn': '为确保流畅的使用体验，请保持手机竖屏。',
  'zh-hk': '為確保流暢的使用體驗，請保持手機豎屏。',
  'en': 'To ensure a smooth user experience, please keep your phone in portrait orientation.',
},

errorRequest: {
  'zh-cn': '网络异常',
  'zh-hk': '網絡異常',
  'en': 'Network abnormal',
},

returnApp:{
   'en': "Return",
   'zh-cn':"返回",
   'zh-hk':"返回"
},

confirm: {
  'zh-cn': '确认',
  'zh-hk': '確認',
  'en': 'Confirm',
},

tip: {
  'zh-cn': '温馨提示',
  'zh-hk': '溫馨提示',
  'en': 'Friendly Reminder',
},

cancelOrder: {
  'zh-cn': '确定取消订单？',
  'zh-hk': '確定取消訂單？',
  'en': 'Are you sure you want to cancel the order?',
},

dispatchOrder: {
  'zh-cn': '确定派发？',
  'zh-hk': '確定派發？',
  'en': 'Are you sure you want to dispatch?',
},

maintenanceError: {
  'zh-cn': '系统维护中',
  'zh-hk': '系統維護中',
  'en': 'System under maintenance',
},

refreshPage: {
  'zh-cn': '请刷新页面',
  'zh-hk': '請刷新頁面',
  'en': 'Please refresh the page',
},

giftNoFound: {
  'zh-cn': '该礼品已下架',
  'zh-hk': '該禮品已下架',
  'en': 'This item is no longer available',
},

loading: {
  'zh-cn': '加载中...',
  'zh-hk': '加載中...',
  'en': 'Loading...',
},

noDataList: {
  'zh-cn': '暂无数据',
  'zh-hk': '暫無數據',
  'en': 'No data yet',
},
router_mShopPreView_currentPageIsInvalid_prev:{
  'zh-cn': "登录失败,请重试",
  'zh-hk': '登錄失敗,請重試',
  'en': 'Login Failed,please try again.',
},
router_mShopPreView_currentPageIsInvalid_next:{
  'zh-cn': "请重新登陆",
  'zh-hk': '請重新登陸',
  'en': 'please login in again',
},
router_mShopPreView_noLogin_prev:{
  'zh-cn': "当前登录信息信息已失效",
  'zh-hk': '頁面已過期，請重新進入',
  'en': 'The page has expired, please re-enter',
},
router_mShopPreView_noLogin_next:{
  'zh-cn': "请重新进入",
  'zh-hk': '請重新進入',
  'en': 'please re-enter',
},
router_mShopPreView_noLogin_tip:{
  'zh-cn': "返回",
  'zh-hk': '返回',
  'en': 'Back',
},
router_mShopPreView_currentPageIsInvalid_tip:{
  'zh-cn': "返回",
  'zh-hk': '返回',
  'en': 'Back',
}

};

// 与页面有关的内容國際化
const viewsObj = {
  GTO:{
    'zh-cn': "上载GTO",
    'zh-hk': '上載GTO',
    'en': 'Upload GTO',
  },
  router_user_GTO_index:{
    'zh-cn': "上载GTO",
    'zh-hk': '上載GTO',
    'en': 'Upload GTO',
  },
router_PropertyGTO_index:{
  'zh-cn': "上载GTO",
  'zh-hk': '上載GTO',
  'en': 'Upload GTO',
},
router_PropertyGTO_index1:{
  'zh-cn': "上载GTO",
  'zh-hk': '上載GTO',
  'en': 'Upload GTO',
},
router_PropertyGTO_pageTiltle:{
  'zh-cn': "待上载的GTO",
  'zh-hk': '待上載的GTO',
  'en': 'Upload GTO',
},
router_PropertyGTO_myUploadRecords:{
  'zh-cn': "我的上载记录",
  'zh-hk': '我的上載記錄',
  'en': 'My Uploaded Record',
},
router_PropertyGTO_UploadRecords:{
  'zh-cn': "上载记录",
  'zh-hk': '上載記錄',
  'en': 'Uploaded Records',
},
router_PropertyGTO_Daily:{
  'zh-cn': "每日",
  'zh-hk': '每日',
  'en': 'Daily',
},
router_PropertyGTO_Monthly:{
  'zh-cn': "每月",
  'zh-hk': '每月',
  'en': 'Monthly',
},
router_PropertyGTO_Day:{
  'zh-cn': "日",
  'zh-hk': '日',
  'en': 'Day',
},
router_PropertyGTO_Month:{
  'zh-cn': "月份",
  'zh-hk': '月份',
  'en': 'Month',
},
router_PropertyGTO_MonthlyAllDay:{
  'zh-cn': "大量上载",
  'zh-hk': '大量上載',
  'en': 'Mass upload GTO',
},
router_PropertyGTO_MonthlyAllMoth:{
  'zh-cn': "大量上载",
  'zh-hk': '大量上載',
  'en': 'Mass upload GTO',
},
router_PropertyGTO_MassUploadDayTip:{
  'zh-cn': "如果要上载其他日期，请用大量上载功能",
  'zh-hk': '如果要上載其他日期，請用大量上載功能',
  'en': 'Please use mass upload if you want to upload other days',
},
router_PropertyGTO_MassUploadMonthTip:{
  'zh-cn': "如果要上载其他月份，请用大量上载功能",
  'zh-hk': '如果要上載其他月份，請用大量上載功能',
  'en': 'Please use mass upload if you want to upload other months',
},
router_PropertyGTO_Date:{
  'zh-cn': "日期",
  'zh-hk': '日期',
  'en': 'Date',
},
router_PropertyGTO_No:{
  'zh-cn': "商铺号码",
  'zh-hk': '商舖號碼',
  'en': 'Kiosk No.',
},
router_PropertyGTO_Name:{
  'zh-cn': "店铺名称",
  'zh-hk': '店舖名稱',
  'en': 'Kiosk Name',
},
router_PropertyGTO_AC_No:{
  'zh-cn': "MTR物业单位编号",
  'zh-hk': 'MTR物業單位編號',
  'en': 'Property A/C Code',
},
router_PropertyGTO_UploadedBy:{
  'zh-cn': "上载者",
  'zh-hk': '上載者',
  'en': 'Uploaded by',
},
router_PropertyGTO_GTO_Amount:{
  'zh-cn': "GTO金额($)",
  'zh-hk': 'GTO金額($)',
  'en': 'GTO Amount($)',
},
router_PropertyGTO_GTO:{
  'zh-cn': "GTO",
  'zh-hk': 'GTO',
  'en': 'GTO',
},
router_PropertyGTO_Click_Upload:{
  'zh-cn': "点击上载",
  'zh-hk': '點擊上載',
  'en': 'CLICK TO UPLOAD',
},
router_PropertyGTO_Enter_Amount:{
  'zh-cn': "输入GTO金额",
  'zh-hk': '輸入GTO金額',
  'en': 'Enter GTO Amount',
},
router_PropertyGTO_Enter_update:{
  'zh-cn': "更新",
  'zh-hk': '更新',
  'en': 'Update',
},
router_PropertyGTO_Enter_Upload:{
  'zh-cn': "上载",
  'zh-hk': '上載',
  'en': 'UPLOAD',
},
router_PropertyGTO_Upload:{
  'zh-cn': "上载",
  'zh-hk': '上載',
  'en': 'Upload',
},
router_PropertyGTO_Submit:{
  'zh-cn': "提交",
  'zh-hk': '提交',
  'en': 'Submit',
},
router_PropertyGTO_pleaseReasonTip:{
  'zh-cn': "请说明原因",
  'zh-hk': '請說明原因',
  'en': 'Please state the reason',
},
router_PropertyGTO_Remark:{
  'zh-cn': "备注",
  'zh-hk': '備注',
  'en': 'Remark',
},
router_PropertyGTO_RemarkTip:{
  'zh-cn': "请填写其他具体原因",
  'zh-hk': '請填寫其他具體原因',
  'en': 'Others:Please specify in remarks',
},
router_PropertyGTO_revenue:{
  'zh-cn': "GTO收入为$0",
  'zh-hk': 'GTO收入為$0',
  'en': 'GTO revenue is $0',
},
router_PropertyGTO_Choosereason:{
  'zh-cn': "选择原因",
  'zh-hk': '選擇原因',
  'en': 'Select reason',
},
router_PropertyGTO_resultTipSuccess:{
  'zh-cn': "上载成功",
  'zh-hk': '上載成功',
  'en': 'Upload Success',
},
router_PropertyGTO_resultTipFail:{
  'zh-cn': "上载失败，请重新上载",
  'zh-hk': '上載失敗，請重新上載',
  'en': 'Upload Failed,Please Re-upload',
},
router_PropertyGTO_keepUpload:{
  'zh-cn': "继续上载",
  'zh-hk': '繼續上載',
  'en': 'Continue to Upload',
},
router_PropertyGTO_backHome:{
  'zh-cn': "返回主页",
  'zh-hk': '返回主頁',
  'en': 'Back To Homepage',
},
router_PropertyGTO_fileRecord:{
  'zh-cn': "已上载文件记录",
  'zh-hk': '已上載文件記錄',
  'en': 'Upload File Record'
},
router_PropertyGTO_DownloadAll:{
  'zh-cn': "下载所有",
  'zh-hk': '下載所有',
  'en': 'Download All'
},
router_PropertyGTO_dailyGto:{
  'zh-cn': "上载每日GTO文件",
  'zh-hk': '上載每日GTO文件',
  'en': 'Upload Daily GTO File'
},
router_PropertyGTO_monthlyGto:{
  'zh-cn': "上载每月GTO文件",
  'zh-hk': '上載每月GTO文件',
  'en': 'Upload Monthly GTO File'
},
router_PropertyGTO_First:{
  'zh-cn': "第一步：",
  'zh-hk': '第一步：',
  'en': 'Step 1: '
},
router_PropertyGTO_second:{
  'zh-cn': "第二步：",
  'zh-hk': '第二步：',
  'en': 'Step 2: '
},
router_PropertyGTO_third:{
  'zh-cn': "第三步：",
  'zh-hk': '第三步：',
  'en': 'Step 3: '
},
router_PropertyGTO_downloadTemplate:{
  'zh-cn': "下载Excel模板",
  'zh-hk': '下載Excel模板',
  'en': 'Download the Excel template'
},
router_PropertyGTO_templateContent:{
  'zh-cn': "按照模板填写内容",
  'zh-hk': '按照模板填寫内容',
  'en': 'Fill in the content according to the template'
},
router_PropertyGTO_FirstDesc:{
  'zh-cn': "如阁下已下载过该模板，可略过此步骤",
  'zh-hk': '如閣下已下載過該模版，可略過此步驟',
  'en': 'If you have already downloaded the template, you can skip this step'
},
router_PropertyGTO_secondDesc:{
  'zh-cn': "请勿更改模板第一行任何内容、位置",
  'zh-hk': '請勿更改模板第一行任何內容、位置',
  'en': 'Do not modify any content or positions in the first row of the template'
},
router_PropertyGTO_thirdDesc:{
  'zh-cn': "上载按照模板填写后的文件",
  'zh-hk': '上載按照模版填寫後的文件',
  'en': 'Upload the file filled in according to the template.'
},
router_PropertyGTO_ClickDailyGTO:{
  'zh-cn': "点击这里上载每日GTO文件",
  'zh-hk': '點擊這裡上載每日GTO文件',
  'en': 'Click here to upload Daily GTO file'
},
router_PropertyGTO_ClickMonthlyGTO:{
  'zh-cn': "点击这里上载每月GTO文件",
  'zh-hk': '點擊這裡上載每月GTO文件',
  'en': 'Click here to upload Monthly GTO file'
},
router_PropertyGTO_uploadFile:{
  'zh-cn': "上载文件",
  'zh-hk': '上載文件',
  'en': 'Upload the file'
},
router_PropertyGTO_total:{
  'zh-cn': "全部：",
  'zh-hk': '全部：',
  'en': 'All: '
},
router_PropertyGTO_effective:{
  'zh-cn': "有效：",
  'zh-hk': '有效：',
  'en': 'Valid: '
},
router_PropertyGTO_strip:{
  'zh-cn': "条",
  'zh-hk': '條',
  'en': '条'
},
router_PropertyGTO_Notuploaded:{
  'zh-cn': "该铺位尚余3个月的gto资料未上载",
  'zh-hk': '該舖位尚餘3個月的gto資料未上載',
  'en': '该铺位尚余3个月的gto资料未上载'
},
router_PropertyGTO_comma:{
    'zh-cn': "，",
    'zh-hk': '，',
    'en': ','
},
router_PropertyGTO_Invalid:{
  'zh-cn': "无效：",
  'zh-hk': '無效：',
  'en': 'Invalid: '
},
router_PropertyGTO_reload:{
  'zh-cn': "重新上载",
  'zh-hk': '重新上載',
  'en': 'Reload'
},
router_PropertyGTO_UploadTime:{
  'zh-cn': "上载时间",
  'zh-hk': '上載時間',
  'en': 'Upload Time'
},
router_PropertyGTO_File:{
  'zh-cn': "文件",
  'zh-hk': '文件',
  'en': 'File'
},
router_PropertyGTO_Operation:{
  'zh-cn': "操作",
  'zh-hk': '操作',
  'en': 'Operation'
},
router_PropertyGTO_Download:{
  'zh-cn': "下载",
  'zh-hk': '下載',
  'en': 'Download'
},
router_PropertyGTO_DownloadAllFile:{
  'zh-cn': "下载所有文件",
  'zh-hk': '下載所有文件',
  'en': 'Download All Files'
},
router_PropertyGTO_Reason:{
  'zh-cn': "原因",
  'zh-hk': '原因',
  'en': 'Reason'
},

router_PropertyGTO_Description:{
  'zh-cn': "错误帮助",
  'zh-hk': '錯誤説明',
  'en': 'Error Description'
},
router_PropertyGTO_checkPending:{
  'zh-cn': "待審核",
  'zh-hk': '待审核',
  'en': 'check pending'
},
router_PropertyGTO_waitcheckPendingTip1:{
  'zh-cn': "上载成功，谢谢！",
  'zh-hk': '上載成功，謝謝！',
  'en': 'Uploaded successfully, thank you!'
},
router_PropertyGTO_waitcheckPendingTip2:{
  'zh-cn': "为了确保准确性，我们可能会与你进行线下沟通，以便进一步确认。",
  'zh-hk': '爲了確保準確性，我們可能會與你進行綫下溝通，以便進一步確認。',
  'en': 'We may communicate with you via offline channels to ensure accuracy'
},
router_PropertyGTO_ViewPassword:{
  'zh-cn': "查看文件密码",
  'zh-hk': '查看文件密碼',
  'en': 'View File Password'
},
router_PropertyGTO_FilePassword:{
  'zh-cn': "文件密码",
  'zh-hk': '文件密碼',
  'en': 'File Password'
},
router_PropertyGTO_mobileTopTip:{
  'zh-cn': "如果要上载其他月份, 请使用网站的大量上载功能",
  'zh-hk': '如果要上載其他月份, 請使用網站的大量上載功能',
  'en': 'Please use mass upload function in website if you want to upload other months'
},



};



export {
publicObj,
viewsObj
}



// WEBPACK FOOTER //
// ./src/utils/locales/public.js